












































import { Component, Vue } from 'vue-property-decorator'
import CardMenu from './Components/CardMenu.vue'
import FilterMenu from './Components/FilterTable.vue'
import FilterDealer from './Components/FilterTablePowerUser.vue'
import TableMenu from './Components/TableMenu.vue'
import BarChart from './Components/BarChart/BarChart.vue'
import { AuthModule } from '@/app/store/modules/auth'
import LineChart from './Components/LineChart/LineChart.vue'
import { AdditionalInfoReportModule } from '@/app/store/modules/additionalInfoReport'

@Component({
  name: 'UserReports',
  components: {
    'filter-menu': FilterMenu,
    'filter-dealer': FilterDealer,
    'bar-chart': BarChart,
    'card-menu': CardMenu,
    'line-chart': LineChart,
    'table-menu': TableMenu,
  },
})
export default class extends Vue {
  public created() {
    AdditionalInfoReportModule.paginationParam.filter.salescode = ''
    AdditionalInfoReportModule.paginationParam.filter.position = ''
    AdditionalInfoReportModule.paginationParam.filter.filecode = ''
    AdditionalInfoReportModule.paginationParam.filter.dealer = ''
    AdditionalInfoReportModule.paginationParam.filter.city = ''
    AdditionalInfoReportModule.paginationParam.filter.branch = ''
    AdditionalInfoReportModule.paginationParam.filter.start = ''
    AdditionalInfoReportModule.paginationParam.filter.end = ''
    this.getAddInfoReportData()
    this.getExportData()
  }
  public get getAddInfoReportData(): any {
    return AdditionalInfoReportModule.getAdditionalInfoData
  }
  public get TopMenuData(): any {
    return AdditionalInfoReportModule.AdditionalInfoData.topMenu
  }
  public get ChatData(): any {
    return AdditionalInfoReportModule.AdditionalInfoData.chart
  }
  public get dataMonthlyAccessCharts(): any {
    return AdditionalInfoReportModule.AdditionalInfoData.monthlyAccessCharts
  }
  public get TopVisit(): any {
    return AdditionalInfoReportModule.AdditionalInfoData.topVisit
  }

  public get isLoading(): boolean {
    return AdditionalInfoReportModule.isLoading
  }
  public get getExportData(): any {
    return AdditionalInfoReportModule.getExportData
  }
  public get linkExport(): any {
    return AdditionalInfoReportModule.exportData.data
  }
  public get isLoadingExport() {
    return AdditionalInfoReportModule.isLoadingExport
  }

  // Property Top Menu
  private funcFilter(data) {
    AdditionalInfoReportModule.paginationParam.filter.salescode = data.salescode
    AdditionalInfoReportModule.paginationParam.filter.position = data.position
    AdditionalInfoReportModule.paginationParam.filter.filecode = data.filecode
    AdditionalInfoReportModule.paginationParam.filter.dealer = data.dealerNameId
    AdditionalInfoReportModule.paginationParam.filter.city = data.cityId
    AdditionalInfoReportModule.paginationParam.filter.branch =
      data.dealerBranchId
    AdditionalInfoReportModule.paginationParam.filter.start = data.filterDate[0]
    AdditionalInfoReportModule.paginationParam.filter.end = data.filterDate[1]
    AdditionalInfoReportModule.paginationParamsExport.filter.start =
      data.filterDate[0]
    AdditionalInfoReportModule.paginationParamsExport.filter.end =
      data.filterDate[1]
    this.getAddInfoReportData()
    this.getExportData()
  }

  private funcClearFilter() {
    this.clearFilter()
    AdditionalInfoReportModule.paginationParam.filter.salescode = ''
    AdditionalInfoReportModule.paginationParam.filter.position = ''
    AdditionalInfoReportModule.paginationParam.filter.dealer = ''
    AdditionalInfoReportModule.paginationParam.filter.dealer = ''
    AdditionalInfoReportModule.paginationParam.filter.city = ''
    AdditionalInfoReportModule.paginationParam.filter.branch = ''
    AdditionalInfoReportModule.paginationParam.filter.start = ''
    AdditionalInfoReportModule.paginationParam.filter.end = ''
    AdditionalInfoReportModule.paginationParamsExport.filter.start = ''
    AdditionalInfoReportModule.paginationParamsExport.filter.end = ''
    this.getAddInfoReportData()
    this.getExportData()
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }

  public get hasFilter(): boolean {
    if (
      AdditionalInfoReportModule.paginationParam.filter.salescode !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.position !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.filecode !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.dealer !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.city !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.branch !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.start !== '' ||
      AdditionalInfoReportModule.paginationParam.filter.end !== ''
    ) {
      return true
    } else {
      return false
    }
  }
  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }

  private nameCharts = 'Trend Total User Visit'
}
